import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-align-justify",
  templateUrl: "./med-icon-align-justify.component.html",
})
export class MedIconAlignJustifyComponent extends SvgMixinComponent {}
